import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { UserService } from 'services/user.service';

@Component({
  selector: 'video-load',
  templateUrl: './video-load.component.html',
  styleUrls: ['./video-load.component.css']
})
export class VideoLoadComponent implements OnInit, OnDestroy {
  public videoUrl: string | null = null;
  public isLoading: boolean = true;
  public hasError: boolean = false;

  @Input() video: string;

  private videoLoadSub?: Subscription;

  constructor(private _http: HttpClient, private _userService: UserService) { }

  ngOnInit() {
    this.loadVideo();
  }

  ngOnDestroy(): void {
    this.videoLoadSub?.unsubscribe();
    this.revokeVideoUrl();
  }

  loadVideo() {
    if (!this.video) {
      this.isLoading = false;
      this.hasError = true;
      return;
    }

    const options = {
      headers: new HttpHeaders({
        'Authorization': 'Bearer ' + this._userService.storageToken,
        'x-ms-version': '2023-08-03',
        'x-ms-date': new Date().toUTCString()
      }),
      responseType: 'blob' as 'json'
    };

    this.videoLoadSub = this._http.get<Blob>(this.video, options)
      .subscribe({
        next: (blobVideo) => {
          this.revokeVideoUrl();
          this.videoUrl = URL.createObjectURL(blobVideo);
          this.isLoading = false;
          this.hasError = false;
        },
        error: () => {
          this.revokeVideoUrl();
          this.videoUrl = null;
          this.isLoading = false;
          this.hasError = true;
        }
      });
  }

  private revokeVideoUrl(): void {
    if (this.videoUrl) {
      URL.revokeObjectURL(this.videoUrl);
      this.videoUrl = null;
    }
  }
}
